// Common button
// ================
// The default button is the secondary button. Pass primary={true} to
// override.

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import style from '../../tools/buttons.scss'
import Spinner from '../spinner'

function dashToCamelCase(string) {
  const str = string.replace(/-([a-z])/g, g => g[1].toUpperCase())
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export default class Button extends Component {
  className(type, disabled = false) {
    return style[`Button${dashToCamelCase(type)}${disabled ? 'Disabled' : ''}`]
  }

  render() {
    const {
      loading,
      disabled,
      type,
      className,
      buttonType,
      ariaLabel,
      id,
      dataTestId,
      ariaPressed,
      onClick,
      children,
      forwardedRef,
      ...props
    } = this.props
    // Always disabled when loading
    const isDisabled = loading || disabled

    const classNames = cx(this.className(type, isDisabled), className)

    const attributes = {}

    if (isDisabled) {
      attributes.disabled = 'disabled'
    }
    if (buttonType) {
      attributes.type = buttonType
    }

    return (
      <button
        onClick={onClick}
        className={classNames}
        aria-label={ariaLabel}
        id={id}
        data-test-id={dataTestId}
        aria-pressed={ariaPressed}
        ref={forwardedRef}
        {...attributes}
        {...props}
      >
        {loading ? (
          <Spinner className={style.Spinner} />
        ) : (
          <span className={style.text}>{children}</span>
        )}
      </button>
    )
  }
}

export const ButtonProps = {
  type: PropTypes.oneOf([
    'primary',
    'secondary',
    'secondary-light',
    'tertiary',
    'tertiary-light',
    'inferior',
  ]),
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
  buttonType: PropTypes.oneOf(['submit', 'reset', 'button']),
  ariaLabel: PropTypes.string,
  ariaPressed: PropTypes.bool,
  id: PropTypes.string,
}

Button.propTypes = ButtonProps

Button.defaultProps = {
  type: 'primary',
  loading: false,
  disabled: false,
}
